module.exports = __webpack_public_path__ + "static/img/card_10@2x.27055b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_10@2x.png
// module id = laZY
// module chunks = 0